export class ListDisplayHelper {

    public static getSelectableListToString(items: ISelectableItem[]): string
    {
        const selectedItems = items? items.filter(x => x.isSelected): [];

        return this.getItemsString(selectedItems);
    }

    public static getListToStringFromIds(items: any[], selectedIds: number[]): string
    {
        const selectedItems = items? items.filter(x => selectedIds.indexOf(x.id) > -1): [];

        return this.getItemsString(selectedItems);
    }

    private static getItemsString(selectedItems: any[]) {
        let string = "";
        if (selectedItems && selectedItems.length > 0) {
            for (let index = 0; index < selectedItems.length; index++) {
                if (index > 1) {
                    string += ` + ${selectedItems.length - 2} more`;
                    break;
                }
                string = string.concat(`${selectedItems[index].name}`)
                if (index != selectedItems.length - 1) {
                    string += ", ";
                }
            }
        }
        return string;
    }
}

export interface ISelectableItem
{
    name: string;
    isSelected: boolean;
}